import React from 'react';
import {styled} from '@mui/material';
import {
  Button,
  designSystemToken,
  Icon,
  Label,
} from '@lightricks/react-design-system';

const ConfigButtonElement = styled(Button)(() => ({
  borderRadius: '999px',
  border: `1px solid ${designSystemToken('semantic.bg.neutral-inverse')}`,
}));

interface ConfigButtonProps {
  testID?: string;
  disabled?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  hideIcon?: boolean;
}

function ConfigButton(props: ConfigButtonProps) {
  const {
    testID = 'config-button',
    disabled = false,
    onClick,
    children,
    hideIcon = false,
  } = props;

  return (
    <ConfigButtonElement
      testID={testID}
      size="small"
      appearance="neutral"
      mode="plain"
      disabled={disabled}
      onClick={onClick}
      startIcon={
        !hideIcon && (
          <Icon
            name="Features-Edit-Basic"
            size="medium"
            appearance="neutral"
            color={
              disabled
                ? designSystemToken('semantic.fg.disabled')
                : designSystemToken('semantic.fg.primary')
            }
          />
        )
      }
    >
      <Label
        size="md"
        color={
          disabled
            ? designSystemToken('semantic.fg.disabled')
            : designSystemToken('semantic.fg.primary')
        }
      >
        {children}
      </Label>
    </ConfigButtonElement>
  );
}

export default ConfigButton;
